export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    // file: [
    //     { required: true, message: 'Пожалуйста, введите content ', trigger: 'change' },
    // ],
};
